import section from '@/configs/template';
export default section;
